module.exports = __webpack_public_path__ + "files/512a83ac26d1574e25d742fe81cf531b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/saturation.png
 ** module id = 831
 ** module chunks = 0
 **/